export default __webpack_public_path__ + "static/media/Metropolis-Bold.a1e10add.woff";